import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BudgetManagementForm } from '@/components/forms/BudgetManagementForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateBudgetManagementPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/budget-management')
  }

  const handleCancel = () => {
    navigate('/budget-management')
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Create Budget Record
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Add a new Budget Record
            </Text>
          </CardHeader>
          <CardBody>
            <BudgetManagementForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


